import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core';

import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';

import { Subject, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { CdkScrollable } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { EnvironmentData } from '@common/data';
import { Organization } from '@common/interfaces';
import { FsAutocompleteChipsModule } from '@firestitch/autocomplete-chips';
import { FsDialogModule } from '@firestitch/dialog';
import { FsFormModule } from '@firestitch/form';


@Component({
    templateUrl: './donate.component.html',
    styleUrls: ['./donate.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        FormsModule,
        FsFormModule,
        FsDialogModule,
        MatDialogTitle,
        CdkScrollable,
        MatDialogContent,
        FsAutocompleteChipsModule,
        MatDialogActions,
        MatButton,
        MatDialogClose,
    ],
})
export class DonateComponent implements OnDestroy {
  private _dialogRef = inject<MatDialogRef<DonateComponent>>(MatDialogRef);
  private _environmentData = inject(EnvironmentData);


  public organization: Organization = null;

  private _destroy$ = new Subject();

  public fetchOrganizations = (keyword) => {
    return this._environmentData.gets({ keyword });
  };

  public save = () => {
    return of(this.organization)
      .pipe(
        tap((response) => this._dialogRef.close(response)),
      );
  };

  public ngOnDestroy(): void {
    this._destroy$.next(null);
    this._destroy$.complete();
  }

}
